<template>
	<ECommercePhysicalSizeSelector
		:heading="content.heading"
		:headingSize="content.headingSize"
	/>
</template>

<script>
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";

export default defineNuxtComponent({
	name: "GizmoECommercePhysicalSizeSelector",
	mixins: [GizmoComponentMixin],
});
</script>
